import React from 'react';
import './Portfolio.css';

function Categories({ filter, categories }) {
    return (
        <div className="btns-tab">
            {categories.map((cat, i) => {
                return (
                    <button
                        type="button"
                        className="btn-portfolio"
                        onClick={() => filter(cat)}
                        key={i}
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title={i}
                    >
                        <i className={cat}></i>
                    </button>
                );
            })}
        </div>
    );
}

export default Categories;
